export default __webpack_public_path__ + "static/media/boleto.14ca4c04.jpg";